module.exports = __webpack_public_path__ + "static/media/icons8-facebook.1aeb9772.svg";